import React from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import Form from "../../common/Form";
import * as types from "../../../constants/ComponentConstants";
import Row from "../../common/Row";
import TextAreaInput from "../../common/TextAreaInput";

const AddNewInfrastructurenForm = (props) => {
    const {
        onChange,
        onCancel,
        onContinue,
        nieuweInfrastructuren,
        nieuweInfraHasFocus
    } = props;

    return (
        <Section
            title={"Eigen voorstel sportinfrastructuur"}
            color={types.COLOR_RED}
        >
            <Form name="Eigen voorstel sportinfrastructuur"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Ga verder"
                onRightButtonClick={onContinue}
                leftButtonLabel="Annuleer"
                onLeftButtonClick={onCancel}
            >
                <Section>
                    <Row>
                        <div className="o-col-10">Gelieve naast de naam van de sportinfrastructuur ook de adresgegevens in te geven.</div>
                    </Row>
                    <br />
                    <Row>
                        <TextAreaInput hasFocus={nieuweInfraHasFocus} value={nieuweInfrastructuren} onChange={onChange} name="nieuweInfrastructuren" label="Eigen voorstel sportinfrastructuur" maxLength={400} />
                    </Row>
                </Section>
            </Form>
        </Section>
    );
};

AddNewInfrastructurenForm.propTypes = {
    onChange: PropTypes.func,
    onCancel: PropTypes.func,
    onContinue: PropTypes.func,
    nieuweInfrastructuren: PropTypes.string,
    nieuweInfraHasFocus: PropTypes.bool
};

export default AddNewInfrastructurenForm;